import { Dialog, DialogTitle, DialogContent, DialogActions, 
  Button, Box, Snackbar, Alert } from "@mui/material";
import * as React from "react";
import FileBrowser from "./FileBrowser";

export default function OpenFileDialog(
  props: {
    open: boolean,
    handleOpen: (filename: string) => void,
    handleCancel: () => void,
    itemSelectionAllowed: (item: any) => boolean
  }
) {
  const [selectedItem, setSelectedItem] = React.useState<any>(null);

  const handleCancel = () => {
    setSelectedItem(null);
    props.handleCancel();
  }

  const handleOpen = () => {
    const path = selectedItem['path'] ? selectedItem['path'] : [];
    let filename = path.length > 0 ? path.join('/') + '/' : '';
    filename += selectedItem ? selectedItem['name'] : '';

    if (filename)
      props.handleOpen(filename);
  }

  return (
    <Dialog open={props.open} PaperProps={{ sx: {height: '70%'} }}
      aria-labelledby="open-project-dialog-title"
      onClose={handleCancel}
      maxWidth="md" fullWidth>
      <DialogTitle id="open-project-dialog-title">
        {'Open Project'}
      </DialogTitle>
      <DialogContent>
        <Box sx={{height: '100%'}} >
          <FileBrowser open={props.open} paths={null}
            setSelectedItem={setSelectedItem} />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button autoFocus 
          disabled={!props.itemSelectionAllowed(selectedItem)}
          onClick={handleOpen}>
          Open
        </Button>
        <Button onClick={handleCancel}>
          Cancel
        </Button>
      </DialogActions>
    </Dialog>
  );
};
